import React, { Component } from 'react'
import PropTypes from 'prop-types'

class App extends Component {
  UNSAFE_componentWillMount () {
    const { location } = this.props
    const { pathname } = location
    if (pathname === '/status') this.props.actions.statusRequest()
  }
  render () {
    const { children, status, location } = this.props
    const { pathname } = location
    if (pathname === '/status') {
      return <span>{status}</span>
    }
    return <div className="login">{children}</div>
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired
}

export default App
